import test from 'conversations/test';
import paul from 'conversations/paul';

export default {
  test,
  paul
}
